/*
 * Выбор варианта на карточках товара (.variant-product-card).
 *
 * Обёрнуто в IIFE с флагом: секция и сниппет оба подключают этот файл,
 * а повторное объявление класса на верхнем уровне валило скрипт
 * с SyntaxError: Identifier 'VariantSelector' has already been declared.
 */
(function () {
  if (window.__variantSelectorInit) return;
  window.__variantSelectorInit = true;

  class VariantSelector {
    constructor(container) {
      this.container = container;
      this.productCards = container.querySelectorAll(".variant-product-card");
      this.selectedVariant = null;
      this.callbacks = { onVariantSelect: [] };
      this.init();
    }

    init() {
      this.productCards.forEach((card, index) => {
        card.addEventListener("click", () => {
          this.selectVariant(index);
        });
      });

      // Выбранную карточку проставляет Liquid по selected_or_first_available_variant.
      // Откат на первую — только если разметка почему-то ничего не отметила.
      const selectedCard = this.container.querySelector(".variant-product-card.selected");
      if (selectedCard) {
        this.selectedVariant = Array.from(this.productCards).indexOf(selectedCard);
      } else if (this.productCards.length > 0) {
        this.selectVariant(0);
      }
    }

    selectVariant(index) {
      if (!this.productCards[index]) return;

      this.productCards.forEach((card) => card.classList.remove("selected"));
      this.productCards[index].classList.add("selected");
      this.selectedVariant = index;

      const variantData = this.getVariantData(index);
      this.callbacks.onVariantSelect.forEach((callback) => callback(variantData, index));

      this.container.dispatchEvent(
        new CustomEvent("variantSelected", {
          detail: { variant: variantData, index: index, element: this.productCards[index] },
        })
      );
    }

    getVariantData(index) {
      const card = this.productCards[index];
      if (!card) return null;

      return {
        title: card.querySelector(".variant-product-title")?.textContent?.trim() || "",
        description: card.querySelector(".variant-product-description")?.textContent?.trim() || "",
        originalPrice: card.querySelector(".variant-original-price")?.textContent?.trim() || "",
        currentPrice: card.querySelector(".variant-current-price")?.textContent?.trim() || "",
        hasBadge: !!card.querySelector(".variant-best-value-badge"),
        badgeText: card.querySelector(".variant-best-value-badge")?.textContent?.trim() || "",
        variantId: card.dataset.variantId || null,
        productId: card.dataset.productId || null,
        variantPrice: card.dataset.variantPrice || null,
        variantComparePrice: card.dataset.variantComparePrice || null,
        variantAvailable: card.dataset.variantAvailable === "true",
      };
    }

    getSelectedVariant() {
      return this.selectedVariant !== null ? this.getVariantData(this.selectedVariant) : null;
    }

    onVariantSelect(callback) {
      this.callbacks.onVariantSelect.push(callback);
    }

    updateVariantColors(colors) {
      if (!colors) return;
      Object.entries(colors).forEach(([property, value]) => {
        if (value) {
          this.container.style.setProperty(`--variant-${property.replace(/_/g, "-")}`, value);
        }
      });
    }
  }

  // Цены всех вариантов, отформатированные в Liquid (блок price в product-info.liquid).
  function readPriceMap() {
    const node = document.querySelector("script[data-variant-prices]");
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      console.warn("[variant-selector] не смог разобрать data-variant-prices", e);
      return null;
    }
  }

  function updatePriceBlock(variantId, priceMap) {
    if (!priceMap) return null;

    const data = priceMap[variantId];
    if (!data) return null;

    document.querySelectorAll("[data-price-block]").forEach((block) => {
      const current = block.querySelector("[data-price-current]");
      const compare = block.querySelector("[data-price-compare]");
      const save = block.querySelector("[data-price-save]");
      const saveText = block.querySelector("[data-price-save-text]");

      if (current) {
        current.textContent = data.price;
        current.classList.toggle("on-sale", !!data.onSale);
      }
      if (compare) {
        compare.textContent = data.compare;
        compare.hidden = !data.onSale;
      }
      if (save) save.hidden = !data.onSale;
      if (saveText) saveText.textContent = data.saveText;
    });

    return data;
  }

  // Кнопку трогаем только если в ней уже была цена — иначе затрём текст,
  // который продавец настроил в редакторе темы.
  function updateAddToCartPrice(oldPrice, newPrice) {
    if (!oldPrice || !newPrice || oldPrice === newPrice) return;

    document
      .querySelectorAll(".shop-add-to-cart-button .button-text, .product-form__submit .button__text, [data-add-to-cart-text]")
      .forEach((el) => {
        if (el.textContent.includes(oldPrice)) {
          el.textContent = el.textContent.split(oldPrice).join(newPrice);
        }
      });
  }

  function setFormVariant(variantId) {
    const productForm =
      (typeof Elixir_GetProductForm === "function" && Elixir_GetProductForm()) ||
      document.querySelector(".shop-add-to-cart-wrapper form[action*='/cart/add']");
    if (!productForm) return;

    const variantInput = productForm.querySelector('input[name="id"], select[name="id"]');
    if (!variantInput) return;

    variantInput.value = variantId;
    variantInput.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function init() {
    const priceMap = readPriceMap();
    let shownPrice = document.querySelector("[data-price-current]")?.textContent.trim() || null;

    document.querySelectorAll(".variant-selector-container").forEach((container) => {
      if (container.variantSelector) return;

      const variantSelector = new VariantSelector(container);
      container.variantSelector = variantSelector;

      variantSelector.onVariantSelect((variantData) => {
        if (!variantData || !variantData.variantId) return;

        setFormVariant(variantData.variantId);

        if (window.history && window.history.replaceState) {
          const url = new URL(window.location);
          url.searchParams.set("variant", variantData.variantId);
          window.history.replaceState({}, "", url);
        }

        const priceData = updatePriceBlock(variantData.variantId, priceMap);
        if (priceData) {
          updateAddToCartPrice(shownPrice, priceData.price);
          shownPrice = priceData.price;
        }

        window.dispatchEvent(new CustomEvent("variantChanged", { detail: variantData }));
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.VariantSelector = VariantSelector;
  window.createVariantSelector = function (container, options = {}) {
    const variantSelector = new VariantSelector(container);
    if (options.colors) variantSelector.updateVariantColors(options.colors);
    if (options.onSelect) variantSelector.onVariantSelect(options.onSelect);
    return variantSelector;
  };
})();
